import React, { useCallback } from 'react';
import ReactTooltip from 'react-tooltip';
import { DRIVER_REVIEW } from 'modules/fleet/events';

import tel from 'utils/phone';

const t = {
  view_job: 'View job detail',
  call_carrier: 'Call carrier',
  call_shipper: 'Call shipper',
  unassign: 'Unassign this job',
  copied: 'Copied!',
};

const TooltipContent = ({ tooltipMetadata, handleUnassign }) => {
  const metadata = JSON.parse(tooltipMetadata || {});

  const { journeyId, driverDayId, carrierPhone, shipperPhone, shipperOrderId, shipperOrderIds } =
    metadata;

  const handleUnassignClick = useCallback(() => {
    handleUnassign(journeyId);
    DRIVER_REVIEW.UNASSIGN({
      driver_day_id: driverDayId,
      journey_id: journeyId,
      shipper_order_id: shipperOrderId,
      shipper_order_ids: shipperOrderIds,
    });
  }, [handleUnassign, journeyId, shipperOrderId, driverDayId, shipperOrderIds]);

  const handleViewJobReview = useCallback(() => {
    DRIVER_REVIEW.OPEN_JOB_DETAIL({
      driver_day_id: driverDayId,
      journey_id: journeyId,
      shipper_order_id: shipperOrderId,
      shipper_order_ids: shipperOrderIds,
    });
  }, [journeyId, shipperOrderId, driverDayId, shipperOrderIds]);

  const handleCallCarrier = useCallback(() => {
    DRIVER_REVIEW.OPEN_JOB_DETAIL({
      driver_day_id: driverDayId,
      journey_id: journeyId,
      shipper_order_id: shipperOrderId,
      shipper_order_ids: shipperOrderIds,
    });
  }, [journeyId, shipperOrderId, driverDayId, shipperOrderIds]);

  const handleCallShipper = useCallback(() => {
    DRIVER_REVIEW.CALL_SHIPPER({
      driver_day_id: driverDayId,
      journey_id: journeyId,
      shipper_order_id: shipperOrderId,
      shipper_order_ids: shipperOrderIds,
    });
  }, [journeyId, shipperOrderId, driverDayId, shipperOrderIds]);

  if (!tooltipMetadata) {
    return null;
  }

  return (
    <div>
      {!!journeyId && (
        <a
          className="action_button"
          href={`/jobs/${journeyId}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleViewJobReview}
        >
          {t.view_job}
        </a>
      )}
      {!!carrierPhone && (
        <a href={tel(`${carrierPhone}`)} className="action_button" onClick={handleCallCarrier}>
          {t.call_carrier}
        </a>
      )}
      {!!shipperPhone && (
        <a href={tel(`${shipperPhone}`)} className="action_button" onClick={handleCallShipper}>
          {t.call_shipper}
        </a>
      )}
      {!!journeyId && (
        <button className="action_button" onClick={handleUnassignClick}>
          {t.unassign}
        </button>
      )}
    </div>
  );
};

const JobReviewActionsTooltip = ({ className, handleUnassign }) => {
  const getContent = (tooltipMetadata) => {
    return !!tooltipMetadata ? (
      <TooltipContent tooltipMetadata={tooltipMetadata} handleUnassign={handleUnassign} />
    ) : null;
  };

  return (
    <ReactTooltip
      id="actions-tooltip"
      place="left"
      type="light"
      effect="solid"
      globalEventOff="click"
      className={className}
      getContent={getContent}
      clickable
      scrollHide={true}
    />
  );
};

export default JobReviewActionsTooltip;
